import { request } from "../../../Services/Api"

export const getRequestsVerifiInform = (params) =>
  request.api.get(`/requests/vamp-requests/`, params)

export const getRequestVerifiInform = async ({ id }) => {
  return request.api.get(`/requests/vamp-requests/${id}/`)
}

export const updateRequestVerifiInformStatus = async ({ id, status, rejectReason }) => {
  return request.api.patch(`/requests/vamp-requests/${id}/update-status/`, {
    status,
    rejected_reason: rejectReason
  })
}
